//QA URL: 'https://futuroco-back.onrender.com/'
//LOCAL URL: 'http://localhost:5000/'
//PRODUCTION URL: 'https://www.compassfaciam.org/backend/'
export const CONSTANTS = {
  base_url: 'https://www.compassfaciam.org/backend/',
  api_url: 'api/v1',
  app_url: 'https://www.compassfaciam.org/login',
  TOKEN: sessionStorage.getItem('logged'),
  DEFAULT_USER_AVATAR: 'https://ui-avatars.com/api/?name='
}